module.exports = __webpack_public_path__ + "media/images/bg03-0e101958a45499029c3000915b37f4dd.png";